import { render, staticRenderFns } from "./AdminWorkspaces.vue?vue&type=template&id=645b9ef5&scoped=true&"
import script from "./AdminWorkspaces.vue?vue&type=script&lang=js&"
export * from "./AdminWorkspaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b9ef5",
  null
  
)

export default component.exports